export default __webpack_public_path__ + "03e3a8be0fc4a6cce39ec7fcfde6258f.png";